// Função auxiliar para verificar se a chave contém uma substring

const keyContains = (key, substring) =>
  key?.toLowerCase()?.includes(substring?.toLowerCase());

const extratcItensFromInterface = (interfaceSelected, itens) => {
  if (!interfaceSelected) {
    return [];
  }
  // Encontrar os itens de tráfego e potência correspondentes
  const traffic = itens?.filter(
    (item) =>
      keyContains(item?.key_, `octets`) &&
      (keyContains(item?.key_, "[" + interfaceSelected?.interface + "]") ||
        keyContains(item?.key_, "[" + interfaceSelected?.interface + " ") ||
        keyContains(item?.key_, "[" + interfaceSelected?.interface + ",")),
  );
  //Encotrar os itens de potência correspondentes
  let power = itens?.filter(
    (item) =>
      (keyContains(item?.key_.replace(/_/g, ""), `rxpower`) ||
        keyContains(item?.key_.replace(/_/g, ""), `txpower`)) &&
      (keyContains(item?.key_, "[" + interfaceSelected?.interface + "]") ||
        keyContains(item?.key_, "[" + interfaceSelected?.interface + " ") ||
        keyContains(item?.key_, "[" + interfaceSelected?.interface + ",")) &&
      !item?.key_?.includes("olt"),
  );
  // se contiver lane ou ramos, pegar apenas o priemiro item
  if (power?.find((a) => /Lane|Ramo/?.test(a?.key_))) {
    power = power?.filter(
      (a) => /Lane 1|Ramo 1/?.test(a?.key_) || !/Lane|Ramo/?.test(a?.key_),
    );
  }
  return [...traffic, ...power];
};
export default extratcItensFromInterface;
